import MainButton from "../MainButton";

function ClassesBox({ bgImg, title, icon }) {
  return (
    <>
      <div
        className={`${bgImg} bg-cover bg-center bg-no-repeat rounded-3xl shadow-2xl flex flex-col h-[46rem] relative p-[40px]`}
      >
        <span className="bg-[#0000004a] rounded-3xl w-full h-full absolute top-0 left-0"></span>

        <div className="flex flex-col align-text-bottom h-full w-full z-[2] justify-end">
          {icon && (
            <img src={icon} alt="icon" className="w-[5rem] h-[5rem] object-contain mb-6 invert" />
          )}
          <p className="text-white font-bold text-[2.7rem] mb-3">{title}</p>

          <span className="bg-[#ff0336] w-[50px] h-[4px]"></span>

          <MainButton
            color={`text-black`}
            bg={`bg-white`}
            cN="mt-14"
            text="join now"
            goTo="/contact"
          />
        </div>
      </div>
    </>
  );
}

export default ClassesBox;
